import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Box, Divider, Typography, Stack, Slide, Button } from "@mui/material";

import { Images } from "./../../assets/common";

import ApiService from "./../../services/api-service";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import Loader from "./../../components/Loader";

import {
  fullName,
  formatedDate,
  isOwner,
  convertHMS,
  getErrorString,
  isOwnerId,
} from "./../../constants/function";
import BidPopup from "../../components/BidPopup";
import SuccessPopup from "../../components/SuccessPopup";
import IosSwitch from "../../components/IOSSwitch";
import SellPopup from "../../components/SellPopup";
import AuctionPopup from "../../components/AuctionPopup";
import { useSelector, useDispatch } from "react-redux";
import notifier from "../../components/Notifier";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useTranslation } from "react-i18next";
export default function BuyInfo() {
  const { t } = useTranslation("common");
  const [type, setType] = React.useState("music");
  const dispatch = useDispatch();
  const songs = useSelector((state) => state.songs);
  const location = useLocation();
  const balance = useSelector((state) => state.balance);
  const [openBid, setOpenBid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [musicDetail, setMusicDetail] = useState({});
  const [owners, setOwners] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [checked, setChecked] = React.useState(false);
  const [showSell, setShowSell] = React.useState(false);
  const [showAuction, setShowAuction] = React.useState(false);
  const { id } = useParams();
  const { playlistNftId } = useParams();
  const [music, setMusic] = useState([]);

  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openBuy, setOpenBuy] = React.useState(false);
  const [buyIndex, setBuyIndex] = React.useState(null);
  const [sellIndex, setSellIndex] = React.useState(null);
  const [index, setIndex] = React.useState(-1);
  const getMusicDetail = async (_id) => {
    try {
      setLoading(true);
      const response = playlistNftId
        ? await ApiService.PLAYLIST_NFT_BY_ID(playlistNftId)
        : await ApiService.NFT_BY_ID(_id);
      setLoading(false);
      if (playlistNftId) {
        response["result"]["musicDetails"] =
          response["result"]["playlistDetails"];
        setMusicDetail({ ...response["result"] });

        getPlaylistDetail(response["result"]["playlistDetails"]["_id"]);
      } else {
        // response["result"][0]["musicDetails"] = response["result"][0][
        //   "musicDetails"
        // ]
        //   ? response["result"][0]["musicDetails"]
        //   : response["result"]["playlistDetails"];

        response["result"][0]["duration"] = response["result"][0]["duration"]
          ? response["result"][0]["duration"]
          : response["result"][0]["musicDetails"]["totalDuration"]
          ? response["result"][0]["musicDetails"]["totalDuration"]
          : response["result"][0]["musicDetails"]["duration"]
          ? response["result"][0]["musicDetails"]["duration"]
          : 0;
        setMusicDetail({ ...response["result"][0] });
        setOwners([...response["result"]]);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    setMusicDetail({});
    setOwners([]);
    setMusic([]);
    getMusicDetail(id ? id : playlistNftId);
  }, [history.location.pathname]);
  useEffect(() => {}, [musicDetail]);
  const playAll = () => {};
  React.useEffect(() => {}, [balance]);
  const handleBid = (bidAmount) => {
    if (bidAmount) {
      const tempMusicDetail = musicDetail;
      tempMusicDetail["highestBid"] = bidAmount["amount"];
      setMusicDetail({ ...tempMusicDetail });
      setOpenBid(false);
      setShowSuccess(true);
    } else setOpenBid(false);
  };

  const handleChange = (value) => {
    markPrivate(value);
  };

  const markPrivate = async () => {
    try {
      const privacy = !musicDetail.private;
      setLoading(true);
      const response = await ApiService.ASSET_PRIVACY({
        assetId: id ? id : playlistNftId,
        type: playlistNftId ? "playlistNFT" : "nft",
        private: privacy,
      });
      //making playlist publisc/private
      const temp = musicDetail;
      setChecked(privacy);
      temp.private = privacy;
      setMusicDetail({ ...temp });

      const response1 = await ApiService.ASSET_PRIVACY({
        assetId: playlistNftId
          ? musicDetail["playlistDetails"]["_id"]
          : musicDetail["musicDetails"]["_id"],
        type: playlistNftId ? "playlist" : "music",
        private: privacy,
      });
      setLoading(false);
      // if (!playlistNftId) getMusicDetail(id ? id : playlistNftId);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSell = (sellAmount) => {
    if (sellAmount) {
      getMusicDetail(id ? id : playlistNftId);
      setShowSell(false);
    } else {
      setShowSell(false);
    }
  };
  const handleAuction = (sellAmount) => {
    if (sellAmount) {
      getMusicDetail(id ? id : playlistNftId);
      setShowAuction(false);
    } else {
      setShowAuction(false);
    }
  };
  const cancelSell = async (type, nftId) => {
    try {
      setLoading(true);
      const payload = {
        nftId: nftId ? nftId : id ? id : playlistNftId,
        type: type,
      };
      const response = await ApiService.CANCEL_SELL(payload);
      setLoading(false);
      getMusicDetail(id ? id : playlistNftId);
    } catch (error) {
      setLoading(false);
    }
  };
  const cancelAuction = async (type) => {
    try {
      setLoading(true);
      const payload = {
        nftId: id ? id : playlistNftId,
        type: type,
      };
      const response = await ApiService.CANCEL_AUCTION_NFT(payload);
      setLoading(false);
      getMusicDetail(id ? id : playlistNftId);
    } catch (error) {
      setLoading(false);
    }
  };
  const buyNft = async (e, currency, count, buyIndex) => {
    setLoading(true);
    try {
      const payload = {
        currency: currency,
      };
      if (count) payload["count"] = count;
      if (buyIndex >= 0) {
        payload["nftId"] = owners[buyIndex]["_id"];
      } else {
        payload["nftId"] = id ? id : playlistNftId;
      }
      const response = playlistNftId
        ? await ApiService.BUY_NFT(payload)
        : await ApiService.BUY_MUSIC_NFT(payload);

      notifier.success(response["result"]);

      setOpenBuy(false);
      setBuyIndex(null);
      getMusicDetail(id ? id : playlistNftId);
      setLoading(false);
    } catch (error) {
      setOpenBuy(false);
      setBuyIndex(null);
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const getPlaylistDetail = async (playlistId) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: playlistId,
        pageNo: 1,
        pageSize: 16,
      });
      setMusic([...response["result"]["music"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  React.useEffect(() => checkForSell(), [owners]);
  const checkForSell = () => {
    for (let index = 0; index < owners.length; index++) {
      if (
        isOwnerId(owners[index]["owner"]["_id"]) &&
        !owners[index]["onSale"] &&
        owners[index]["currentCount"] &&
        owners[index]["currentCount"] > 0 &&
        (!owners[index]["inSaleCount"] ||
          owners[index]["currentCount"] === owners[index]["inSaleCount"] ||
          owners[index]["currentCount"] > owners[index]["inSaleCount"])
        // (!owners[index]["inSaleCount"] ||
        //   (owners[index]["currentCount"] > owners[index]["inSaleCount"] &&
        //     !owners[index]["onSale"]) ||
        //   (owners[index]["currentCount"] === owners[index]["inSaleCount"] &&
        //     !owners[index]["onSale"]))
      ) {
        setIndex(index);
        return;
      }
    }
    setIndex(-1);
  };
  React.useEffect(() => {}, [index]);
  return (
    <Box sx={{ paddingBottom: "100px" }}>
      <Box
        sx={{
          color: "#999999",
          display: "flex",
          alignItems: "center",
          padding: "0 20px 20px",
        }}
        className="_cp fs-14"
        onClick={() => history.goBack()}
      >
        <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} /> Back
      </Box>
      <Box sx={{ position: "relative" }}>
        <Box>
          <Stack
            spacing={1.5}
            direction="row"
            alignItems="center"
            gap="20px"
            padding="10px 20px"
          >
            <img
              className="_img_medium  br16"
              src={
                musicDetail["musicDetails"]
                  ? musicDetail["musicDetails"]["thumbnailImg"]
                    ? musicDetail["musicDetails"]["thumbnailImg"]["filePath"]
                    : musicDetail["musicDetails"]["GIF"]
                    ? musicDetail["musicDetails"]["GIF"]["filePath"]
                    : Images.album
                  : Images.album
              }
              alt="music"
            />
            <Stack direction="column" justifyContent="center" spacing={1}>
              {!playlistNftId ? (
                <>
                  <Typography className="fs-20">
                    {musicDetail["musicDetails"]
                      ? musicDetail["musicDetails"]["title"]
                      : ""}
                  </Typography>
                  <Typography className="fs-16">
                    {musicDetail["musicDetails"]
                      ? musicDetail["musicDetails"]["artist"]
                      : ""}
                  </Typography>
                </>
              ) : (
                <Typography className="fs-20">
                  {musicDetail["musicDetails"]
                    ? musicDetail["musicDetails"]["title"]
                    : ""}
                </Typography>
              )}

              <Typography
                className={"fs-14 fade-text-60"}
                sx={{ marginTop: "0 !important" }}
                align="left"
              >
                {musicDetail["musicDetails"]
                  ? fullName(
                      musicDetail["owner"]
                        ? musicDetail["owner"]
                        : musicDetail["musicDetails"] &&
                          musicDetail["musicDetails"]["owner"]
                        ? musicDetail["musicDetails"]["owner"]
                        : ""
                    )
                  : ""}
              </Typography>

              <Stack
                direction="row"
                justifyContent="flex-start"
                spacing={1}
                sx={{ marginTop: "0 !important" }}
              >
                {musicDetail["playlistDetails"] ? (
                  <Typography className="fs-14 fw-b">
                    {musicDetail["playlistDetails"]["music"].length} Songs
                  </Typography>
                ) : null}

                <Typography className="fs-14" sx={{ color: "#FFFFFFCC" }}>
                  {convertHMS(musicDetail["duration"])}
                </Typography>
              </Stack>

              <Stack direction="row" spacing={2}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <VisibilityIcon color="default" />{" "}
                  <Typography className="fs-14 fw-b">
                    Views:{" "}
                    {musicDetail["musicDetails"]
                      ? musicDetail["musicDetails"]["views"]
                      : ""}
                  </Typography>
                </Stack>
                <Divider orientation="vertical" />
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    style={{ width: "15px", height: "15px" }}
                    src={Images.listen}
                  />{" "}
                  <Typography className="fs-14 fw-b">
                    Streams:{" "}
                    {musicDetail["musicDetails"]
                      ? musicDetail["musicDetails"]["listens"]
                      : ""}
                  </Typography>
                </Stack>
                <Divider orientation="vertical" />
                {index >= 0 &&
                isOwner(
                  owners[index]["owner"] ? owners[index]["owner"]["email"] : ""
                ) &&
                !playlistNftId ? (
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography className="fs-16">
                      Make asset{" "}
                      {owners[index]["musicDetails"]["private"]
                        ? "public"
                        : "private"}
                    </Typography>
                    <IosSwitch
                      width={true}
                      checked={musicDetail["private"]}
                      handleChange={handleChange}
                    />
                  </Stack>
                ) : null}
                {isOwner(
                  musicDetail["owner"] ? musicDetail["owner"]["email"] : ""
                ) && playlistNftId ? (
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography className="fs-16">
                      Make asset {musicDetail["private"] ? "public" : "private"}
                    </Typography>
                    <IosSwitch
                      width={true}
                      checked={musicDetail["private"]}
                      handleChange={handleChange}
                    />
                  </Stack>
                ) : null}
              </Stack>
              {playlistNftId ? (
                isOwner(
                  musicDetail["owner"] ? musicDetail["owner"]["email"] : ""
                ) ? (
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap="20px"
                    sx={{
                      padding: "10px 0",
                      height: "58px",
                    }}
                  >
                    {/* {musicDetail["onSale"] ? null : (
                      <Button
                        sx={{ width: "97px" }}
                        className="__hover_button fs-15"
                        variant="outlined"
                        color="default"
                        onClick={() => {
                          if (
                            musicDetail["playlistDetails"] &&
                            typeof musicDetail["playlistDetails"]["music"] ===
                              "object" &&
                            musicDetail["playlistDetails"]["music"].length === 0
                          )
                            notifier.warning("Add song to playlist");
                          else {
                            setType(!playlistNftId ? "music" : "playlist");
                            setShowSell(true);
                          }
                        }}
                      >
                        Sell
                      </Button>
                    )} */}
                    {/* TODO: compressed for now */}
                    {/* {location.pathname.includes("/app/SellAuctionPlayList") ? (
                      musicDetail["onAuction"] ? null : (
                        <Button
                          sx={{ width: "97px" }}
                          className="__hover_button fs-15"
                          variant="outlined"
                          color="default"
                          onClick={() => {
                            if (
                              musicDetail["playlistDetails"] &&
                              typeof musicDetail["playlistDetails"]["music"] ===
                              "object" &&
                              musicDetail["playlistDetails"]["music"].length ===
                              0
                            )
                              notifier.warning("Add song to playlist");
                            else {
                              setType(
                                musicDetail["type"] ? "music" : "playlist"
                              );
                              setShowAuction(true);
                            }
                          }}
                        >
                          Auction
                        </Button>
                      )
                    ) : null} */}
                  </Stack>
                ) : null
              ) : null}
              {!playlistNftId && id && index >= 0 ? (
                <Stack
                  direction="row"
                  alignItems="center"
                  gap="20px"
                  sx={{
                    padding: "10px 0",
                    height: "58px",
                  }}
                >
                  {/* {index >= 0 ? (
                    <Button
                      sx={{ width: "97px" }}
                      className="__hover_button fs-15"
                      variant="outlined"
                      color="default"
                      onClick={() => {
                        setType("music");
                        setShowSell(true);
                      }}
                    >
                      Sell
                    </Button>
                  ) : null} */}
                  {/* TODO: compressed for now */}
                  {/* {location.pathname.includes("/app/SellAuctionPlayList") ? (
                    musicDetail["onAuction"] ? null : (
                      <Button
                        sx={{ width: "97px" }}
                        className="__hover_button fs-15"
                        variant="outlined"
                        color="default"
                        onClick={() => {
                          if (
                            musicDetail["playlistDetails"] &&
                            typeof musicDetail["playlistDetails"]["music"] ===
                            "object" &&
                            musicDetail["playlistDetails"]["music"].length === 0
                          )
                            notifier.warning("Add song to playlist");
                          else {
                            setType(musicDetail["type"] ? "music" : "playlist");
                            setShowAuction(true);
                          }
                        }}
                      >
                        Auction
                      </Button>
                    )
                  ) : null} */}
                </Stack>
              ) : null}
            </Stack>
          </Stack>
        </Box>
        <Box className="__back_cover">
          <img
            className=" mx-auto h100 w100 "
            src={
              musicDetail["musicDetails"]
                ? musicDetail["musicDetails"]["thumbnailImg"]
                  ? musicDetail["musicDetails"]["thumbnailImg"]["filePath"]
                  : musicDetail["musicDetails"]["GIF"]
                  ? musicDetail["musicDetails"]["GIF"]["filePath"]
                  : Images.album
                : Images.album
            }
            alt="music"
          />
        </Box>
      </Box>
      <Box
        className="__main_pading"
        sx={{ marginTop: "1rem", background: "#1E1E1E", paddingTop: "18px" }}
      >
        <Stack
          spacing={playlistNftId ? 0 : 1.5}
          direction={playlistNftId ? "row" : "column"}
          justifyContent={playlistNftId ? "space-between" : ""}
          alignItems={playlistNftId ? "balseline" : ""}
        >
          {id ? (
            <Typography
              sx={{
                padding: "0 10px",
              }}
              color="primary"
            >
              Owner Royalty :
              {musicDetail["musicDetails"]
                ? musicDetail["musicDetails"]["ownerRoyalty"]
                : ""}
              %
            </Typography>
          ) : null}
          {musicDetail["musicDetails"] && musicDetail["nftCount"] ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                padding: "10px",
                height: "58px",
              }}
            >
              <Stack>
                <Typography className="fs-13 fade-text">
                  Number of NFTs
                </Typography>
                <Typography className="fs-17">
                  {musicDetail["nftCount"]}
                </Typography>
              </Stack>

              {/* {musicDetail["onSale"] ? (
                location.pathname.includes("SellAuctionPlayList") &&
                isOwner(
                  musicDetail["owner"] ? musicDetail["owner"]["email"] : ""
                ) ? (
                  id ? null : (
                    <Stack
                      className="_cp"
                      direction="row"
                      alignItems="center"
                      gap="4px"
                      onClick={() => {
                        setType(musicDetail["type"] ? "music" : "playlist");
                        cancelSell(musicDetail["type"] ? "music" : "playlist");
                      }}
                    >
                      <CancelTwoToneIcon color="error" />
                      <Typography color="error" className="fs-12 text-fade">
                        Cancel
                      </Typography>
                    </Stack>
                  )
                ) : (
                  <Stack alignItems="center">
                    <Button
                      onClick={() => buyNft()}
                      sx={{ width: "97px" }}
                      variant="outlined"
                      color="default"
                    >
                      Buy
                    </Button>
                    <Typography className="fs-12 text-fade">On Sale</Typography>
                  </Stack>
                )
              ) : null} */}
            </Stack>
          ) : null}
          {musicDetail["owner"] ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                padding: "10px",
                height: "58px",
              }}
            >
              <Stack>
                <Typography className="fs-13 fade-text">
                  NFT Created Date
                </Typography>
                <Typography className="fs-17">
                  {formatedDate(musicDetail["createdDate"])}
                </Typography>
              </Stack>
            </Stack>
          ) : null}
          {playlistNftId ? (
            <Stack
              direction="column"
              justifyContent="space-between"
              alignItems="flex-start"
              sx={{
                padding: "10px",
                height: "58px",
              }}
            >
              <Stack>
                <Typography className="fs-13 fade-text">
                  Last selling price
                </Typography>
                <Typography className="fs-17">
                  {musicDetail["sellingPrice"]} Siki tokens
                </Typography>
              </Stack>
              {musicDetail["onSale"] ? (
                location.pathname.includes("SellAuction") &&
                isOwner(
                  musicDetail["owner"] ? musicDetail["owner"]["email"] : ""
                ) ? (
                  <Stack
                    className="_cp"
                    direction="row"
                    alignItems="center"
                    gap="4px"
                    onClick={() => {
                      setType(musicDetail["type"] ? "music" : "playlist");
                      cancelSell(musicDetail["type"] ? "music" : "playlist");
                    }}
                  >
                    <CancelTwoToneIcon color="error" />
                    <Typography color="error" className="fs-12 text-fade">
                      Cancel
                    </Typography>
                  </Stack>
                ) : (
                  <Stack alignItems="center">
                    <Button
                      onClick={() => buyNft()}
                      sx={{ width: "97px" }}
                      variant="outlined"
                      color="default"
                    >
                      Buy
                    </Button>
                    <Typography className="fs-12 text-fade">On Sale</Typography>
                  </Stack>
                )
              ) : null}
            </Stack>
          ) : null}
          {/* TODO: compressed for now */}
          {playlistNftId ? (
            <Stack
              direction="column"
              justifyContent="space-between"
              alignItems="flex-start"
              sx={{
                padding: "10px",
                height: "58px",
              }}
            >
              <Stack>
                <Typography className="fs-13 fade-text">Highest Bid</Typography>
                <Typography className="fs-17">
                  {musicDetail["highestBid"] && musicDetail["onAuction"]
                    ? musicDetail["highestBid"]
                    : 0}{" "}
                  Siki tokens
                </Typography>
              </Stack>
              {musicDetail["auctionId"] && musicDetail["onAuction"] ? (
                location.pathname.includes("SellAuction") &&
                isOwner(
                  musicDetail["owner"] ? musicDetail["owner"]["email"] : ""
                ) ? (
                  <Stack
                    className="_cp"
                    direction="row"
                    alignItems="center"
                    gap="4px"
                    onClick={() => {
                      setType(musicDetail["type"] ? "music" : "playlist");
                      cancelAuction(musicDetail["type"] ? "music" : "playlist");
                    }}
                  >
                    <CancelTwoToneIcon color="error" />
                    <Typography color="error" className="fs-12 text-fade">
                      Cancel
                    </Typography>
                  </Stack>
                ) : (
                  <Stack alignItems="center">
                    <Button
                      sx={{ width: "97px" }}
                      variant="outlined"
                      color="default"
                      onClick={() => setOpenBid(true)}
                    >
                      Bid
                    </Button>
                    <Typography className="fs-12 success">
                      {musicDetail["startDateString"]}
                    </Typography>
                  </Stack>
                )
              ) : null}
            </Stack>
          ) : null}
          {owners && owners.length > 0 ? (
            <Stack spacing={1} sx={{ padding: "10px" }}>
              <Typography className="fs-13 fade-text-60">
                NFT Owned By ({owners.length})
              </Typography>
              {owners.map((owner, index) => (
                <Stack
                  key={index}
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ marginBottom: "15px" }}
                >
                  <Stack>
                    <img
                      className="avatar"
                      src={
                        owner["owner"]["profileImg"] &&
                        owner["owner"]["profileImg"]["filePath"]
                          ? owner["owner"]["profileImg"]["filePath"]
                          : Images.user_dummy
                      }
                      alt="owner"
                    />
                  </Stack>
                  <Stack>
                    <Typography className="fs-14 ">
                      {fullName(owner["owner"])}
                    </Typography>
                    <Typography className="fs-13 fade-text-60">
                      NFT on sale: {owner["onSale"] ? owner["inSaleCount"] : 0}/
                      {owner["currentCount"]}
                    </Typography>
                  </Stack>
                  {isOwnerId(owner["owner"] ? owner["owner"]["_id"] : null) ? (
                    owner["onSale"] && owner["inSaleCount"] ? (
                      <Stack
                        sx={{ marginLeft: "auto !important" }}
                        className="_cp"
                        direction="row"
                        alignItems="center"
                        gap="4px"
                        onClick={() => {
                          setType(musicDetail["type"] ? "music" : "playlist");
                          cancelSell(
                            musicDetail["type"] ? "music" : "playlist",
                            owner["_id"]
                          );
                        }}
                      >
                        <CancelTwoToneIcon color="error" />
                        <Typography color="error" className="fs-12 text-fade">
                          Cancel
                        </Typography>
                      </Stack>
                    ) : null
                  ) : isOwnerId(
                      owner["owner"] ? owner["owner"]["_id"] : null
                    ) ? null : (
                    <Stack sx={{ marginLeft: "auto !important" }} spacing={0.5}>
                      {owner["onSale"] && owner["inSaleCount"] ? (
                        <Button
                          variant="outlined"
                          color="default"
                          onClick={() => {
                            setBuyIndex(index);
                            setOpenBuy(true);
                          }}
                          disabled={!owner["onSale"]}
                        >
                          Buy
                        </Button>
                      ) : null}
                      {owner["onSale"] && owner["inSaleCount"] ? (
                        <Stack direction="row" gap="5px" alignItems="center">
                          <Typography
                            className="fs-13 "
                            sx={{ color: "#62FFE1" }}
                          >
                            @ {owner["sellingPrice"].toFixed(4)}
                          </Typography>
                          <img
                            style={{ width: "20px" }}
                            src={Images.siki_coin}
                            alt="siki coin"
                          />
                          <Typography
                            className="fs-13"
                            sx={{ color: "#62FFE1" }}
                          >
                            /nft
                          </Typography>
                        </Stack>
                      ) : null}
                    </Stack>
                  )}
                </Stack>
              ))}
            </Stack>
          ) : null}
          {playlistNftId && musicDetail["owner"] ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                padding: "10px",
                height: "58px",
              }}
            >
              <Stack>
                <Typography className="fs-13 fade-text">
                  NFT Owned By
                </Typography>
                <Typography className="fs-17">
                  {fullName(musicDetail["owner"])}
                </Typography>
              </Stack>
            </Stack>
          ) : null}
        </Stack>
        {music && music.length > 0 ? (
          <>
            <Box
              sx={{
                backgroundColor: "#262626",
                borderRadius: "6px",
                marginTop: "16px",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ padding: "12px 16px" }}
              >
                <Typography className="fs-14 fade-text">Songs</Typography>
                <Typography className="fs-14 fade-text ml_auto">
                  Time
                </Typography>
                <Typography
                  className="fs-14 fade-text"
                  sx={{ visibility: "hidden" }}
                >
                  Action button
                </Typography>
              </Stack>
              <Stack>
                {music.map((m, index) => (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    key={index}
                    className="__playlistNft_music"
                    onClick={() =>
                      m["nftId"]
                        ? history.push(`/app/SellAuction/${m["nftId"]}`)
                        : null
                    }
                  >
                    <Stack direction="row" spacing={1} alignItems="center">
                      <img
                        className="avatar"
                        src={m["thumbnailImg"]["filePath"]}
                        alt="cover"
                      />
                      <Stack direction="column">
                        <Typography className="fs-16">{m["title"]}</Typography>
                        <Typography className="fs-14 fade-text-60">
                          {m["owner"]
                            ? fullName(m["owner"])
                            : fullName(m["uploader"])}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Typography className="fs-13 faded ml_auto">
                      {convertHMS(m["duration"])}
                    </Typography>
                    <Stack sx={{ width: "73px" }}>
                      <img
                        className="__playlistNft_music_back"
                        src={Images.back}
                        alt="back"
                      />
                    </Stack>
                  </Stack>
                ))}
              </Stack>
            </Box>
          </>
        ) : null}
      </Box>

      {loading ? <Loader /> : null}
      {openBuy && buyIndex >= 0 ? (
        <BidPopup
          inSaleCount={owners[buyIndex]["inSaleCount"]}
          isBuy={true}
          open={openBuy}
          handleClose={(e, currency, count) =>
            e && currency
              ? buyNft(e, currency, count, buyIndex)
              : setOpenBuy(false)
          }
          sellingPrice={owners[buyIndex]["sellingPrice"]}
        />
      ) : null}
      {openBid ? (
        <BidPopup
          highestBid={musicDetail["highestBid"]}
          open={openBid}
          handleClose={(amount) => handleBid(amount)}
          auctionId={musicDetail["auctionId"]}
        />
      ) : null}
      {showSuccess ? (
        <SuccessPopup
          open={showSuccess}
          handleClose={() => setShowSuccess(false)}
          message={t("success.message2")}
        />
      ) : null}
      {showSell ? (
        <SellPopup
          type={type}
          open={showSell}
          handleClose={(amount) => handleSell(amount)}
          nftId={index >= 0 ? owners[index]["_id"] : musicDetail["_id"]}
          nftCount={
            index >= 0
              ? typeof owners[index]["inSaleCount"] === "undefined"
                ? owners[index]["currentCount"]
                : owners[index]["currentCount"] > owners[index]["inSaleCount"]
                ? owners[index]["currentCount"]
                : owners[index]["inSaleCount"]
              : musicDetail["inSaleCount"]
              ? musicDetail["inSaleCount"]
              : musicDetail["nftCount"]
          }
        />
      ) : null}
      {showAuction ? (
        <AuctionPopup
          type={type}
          open={showAuction}
          handleClose={(amount) => handleAuction(amount)}
          nftId={musicDetail["_id"]}
        />
      ) : null}
    </Box>
  );
}
